export const MERCHANT_TOKEN = 'registration-token';
export const EMAIL_VERIFICATION_TOKEN = 'email-verification';
